'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LeftNavButton = function LeftNavButton(_ref) {
  var currentSlide = _ref.currentSlide,
      slideCount = _ref.slideCount,
      props = _objectWithoutProperties(_ref, ['currentSlide', 'slideCount']);

  return _react2.default.createElement(
    'div',
    props,
    _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeSolidSvgIcons.faChevronLeft })
  );
};

LeftNavButton.propTypes = process.env.NODE_ENV !== "production" ? {
  currentSlide: _propTypes2.default.number,
  slideCount: _propTypes2.default.number
} : {};

LeftNavButton.defaultProps = {
  currentSlide: undefined,
  slideCount: undefined
};

exports.default = LeftNavButton;
module.exports = exports['default'];